'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleClick = function handleClick(ctaLocation) {
  return window.analytics.track('Clicked Subscribe CTA', { ctaLocation: ctaLocation });
};

var CTA = function CTA(_ref) {
  var className = _ref.className,
      children = _ref.children,
      ctaLocation = _ref.ctaLocation;
  return _react2.default.createElement(
    'a',
    { href: '/upgrade', className: className, onClick: function onClick() {
        return handleClick(ctaLocation);
      } },
    children
  );
};

CTA.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  ctaLocation: _propTypes2.default.string
};

exports.default = CTA;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflinePageContainer/CTA.js
// module id = 672
// module chunks = 11